import React, { createContext, useContext, useEffect, useState } from 'react';
import categoryService from '../services/categoryService';
import { useBeta } from './BetaContext';

const CategoriesContext = createContext(null);

export const CategoriesProvider = ({ children }) => {
  const { activePartyId } = useBeta();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!activePartyId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = categoryService.subscribeToCategories(
      activePartyId,
      (data) => {
        setCategories(data);
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [activePartyId]);

  const value = {
    categories,
    loading,
    error,
  };

  return (
    <CategoriesContext.Provider value={value}>
      {children}
    </CategoriesContext.Provider>
  );
};

export const useCategories = () => {
  const context = useContext(CategoriesContext);
  if (!context) {
    throw new Error('useCategories must be used within a CategoriesProvider');
  }
  return context;
};
